import React from 'react';

const onAddToAnyShare = (data: Record<string, any> = {}) => {
  if (!data?.node?.className) return;
  data?.node
    ?.closest('body')
    ?.querySelector('.a2a_kit')
    ?.dispatchEvent(
      new CustomEvent('social-share-event', {
        bubbles: true,
        detail: {
          target: {
            method: data.service,
            linkUrl: data.url,
            linkText: data.title,
            type: 'icon',
          },
        },
      }),
    );
};

const appendScript = (setScriptLoaded: any) => {
  if (window?.a2a) {
    setScriptLoaded(true);

    /**
     * This is to reinitialize the a2a script when the page is changed.
     */
    window.a2a.init('page');
    return;
  }

  const script = document.createElement('script');
  script.src = 'https://static.addtoany.com/menu/page.js';
  script.onload = () => {
    if (window?.a2a_config) {
      window.a2a_config.callbacks = window.a2a_config.callbacks || [];
      window.a2a_config.callbacks.push({
        share: onAddToAnyShare,
      });
    }

    if (!window?.a2a) return;
    setScriptLoaded(true);
  };
  document.body.appendChild(script);
};

export const useAddToAny = () => {
  const [scriptLoaded, setScriptLoaded] = React.useState(false);

  React.useEffect(() => {
    appendScript(setScriptLoaded);
  }, [scriptLoaded]);
};

declare global {
  interface Window {
    a2a: any;
    a2a_config: any;
  }
}
